// extracted by mini-css-extract-plugin
export default {"container":"_3QxERE1E6z4Z6ljNSfAnD8","tab":"_2G8WXLxf4Q6rXjHlXJqBTS","selectedTab":"_1a6uxIQ14XT_sMssyXh5b8"};